export const ROWS_TO_FETCH = 2;

export const CARDS_PER_ROW = {
  s: 2,
  m: 3,
  l: 2,
  xl: 3,
};

export const ITEMS_PER_ROWS_DEFAULT = {
  s: 2,
  m: 4,
  l: 3,
  xl: 3,
};
